import React, { useState } from 'react'
import IButton from '../1elements/Buttons/IButton'
import IMenu from '../2compounds/IMenu'
import ILink from '../1elements/ILink'
import ITooltip from '../1elements/ITooltip'
import {establishOrRefreshSession} from '../../common/sessionGate'
import word from "../1elements/Icons/svg/microsoft-word.svg"
import excel from '../1elements/Icons/svg/microsoft-excell.svg'
import outlook from "../1elements/Icons/svg/microsoft-outlook.svg"
import onedrive from "../1elements/Icons/svg/microsoft-onedrive.svg"
import teams from "../1elements/Icons/svg/microsoft-teams.svg"
import oneNote from "../1elements/Icons/svg/microsoft-onenote.svg"
import powerPoint from "../1elements/Icons/svg/microsoft-powerpoint.svg"
import AppIcon from '../1elements/Icons/js/icons/AppIcon'

export default function AppsMenuMicrosoft () {
    const [anchorEl, setAnchorEl] = useState(null)

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
        establishOrRefreshSession()
    }

    const handleClose = () => {
        setAnchorEl(null)
        establishOrRefreshSession()
    }

    const open = Boolean(anchorEl);
    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
        establishOrRefreshSession()
    }

    return (
      <div>
          <ITooltip content='Apps' placement='right' arrow>
              <IButton
                isMenu
                handleClick={handleClick}
                opened={Boolean(anchorEl)}
              >
                  <AppIcon />
              </IButton>
          </ITooltip>

          <IMenu
            position='left_center'
            type='icon'
            anchorEl={anchorEl}
            open={open}
            handleClose={handleClose}
          >
              <ILink onClick={ () => openInNewTab("https://www.office.com/launch/word")}>
                  <ITooltip content="Word" placement="top">
                      <img src={word} alt="Word" style={{width: 25, height: 25}}/>
                  </ITooltip>
              </ILink>
              <ILink onClick={() => openInNewTab('https://www.office.com/launch/excel')}>
                  <ITooltip content='Excel' placement='top'>
                      <img
                        src={excel}
                        alt='Excel'
                        style={{ width: 25, height: 25 }}
                      />
                  </ITooltip>
              </ILink>
              <ILink onClick={() => openInNewTab('https://www.office.com/launch/powerpoint')}>
                  <ITooltip content='PowerPoint' placement='top'>
                      <img
                        src={powerPoint}
                        alt='Skype'
                        style={{ width: 25, height: 25 }}
                      />
                  </ITooltip>
              </ILink>
              <ILink onClick={() => openInNewTab('https://outlook.live.com')}>
                  <ITooltip content='Outlook' placement='top'>
                      <img src={outlook} alt='Outlook' style={{ width: 25, height: 25 }} />
                  </ITooltip>
              </ILink>
              <ILink onClick={() => openInNewTab('https://www.onenote.com/')}>
                  <ITooltip content='One Note' placement='top'>
                      <img
                        src={oneNote}
                        alt='One Note'
                        style={{ width: 25, height: 25 }}
                      />
                  </ITooltip>
              </ILink>
              <ILink onClick={() => openInNewTab('https://onedrive.live.com')}>
                  <ITooltip content='OneDrive' placement='top'>
                      <img
                        src={onedrive}
                        alt='OneDrive'
                        style={{ width: 25, height: 25 }}
                      />
                  </ITooltip>
              </ILink>
              <ILink onClick={() => openInNewTab('https://teams.live.com')}>
                  <ITooltip content='Microsoft Teams' placement='top'>
                      <img
                        src={teams}
                        alt='Microsoft Teams'
                        style={{ width: 25, height: 25 }}
                      />
                  </ITooltip>
              </ILink>
          </IMenu>
      </div>
    )
}